import { useState } from "react"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import TenantCustomerAddSelectorDialog from "@/v2-backoffice-client/tenant/customer/add/TenantCustomerAddSelectorDialog"

export type TenantCustomerAddSelectorDialogMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  tenantId: number
  tenantName?: string
  externalCustomerId?: string | null
}

function TenantCustomerAddSelectorDialogMenuItem(
  props: TenantCustomerAddSelectorDialogMenuItemProps,
) {
  const {
    tenantId,
    tenantName,
    externalCustomerId,
    children,
    ...menuItemProps
  } = props

  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <ActionMenu.Item
        iconSrc="users-alt"
        onSelect={(e) => {
          e.preventDefault()
          setIsOpen(true)
        }}
        {...menuItemProps}
      >
        {children ?? "Update Customer"}
      </ActionMenu.Item>

      <TenantCustomerAddSelectorDialog
        open={isOpen}
        onOpenChange={setIsOpen}
        tenantId={tenantId}
        tenantName={tenantName}
        externalCustomerId={externalCustomerId}
      />
    </>
  )
}

export default TenantCustomerAddSelectorDialogMenuItem
